import { useTranslation } from 'react-i18next';
import { useDirectSaleStore } from '@/stores/directSaleStore';
import { DirectSaleCatalog } from './DirectSaleCatalog';

/**
 * Step 1: the customer picks the one product they will design.
 *
 * This is a catalogue, not the Seller Creator's multi-select grid — Direct
 * Sale designs exactly one product, so selecting immediately advances rather
 * than accumulating a basket of products.
 */
export function DirectSaleProductStep() {
  const { t } = useTranslation();
  const selectedProductId = useDirectSaleStore((s) => s.productId);
  const selectProduct = useDirectSaleStore((s) => s.selectProduct);

  return (
    <div className="mx-auto w-full max-w-7xl px-4 pb-24 pt-6">
      <h1 className="text-[clamp(20px,4vw,28px)] font-extrabold text-ink">
        {t('directSale.product.title')}
      </h1>
      <p className="mb-4 mt-1 text-sm text-mute">
        {t('directSale.product.subtitle')}
      </p>

      <DirectSaleCatalog
        selectedProductId={selectedProductId}
        selectedLabel={t('directSale.product.selected')}
        onSelect={(product) => selectProduct(product.id)}
      />
    </div>
  );
}
